import Navbar from "../components/Navbar/Navbar";

import Footer from "../components/Footer/Footer";
import { Link } from "react-router-dom";

function Error() {
  document.title = "Kasa - Erreur 404";
  return (
    <div className="Error">
      <Navbar />
      <main>
        <section className="error">
          <div className="container container--error">
            <h1 className="error-title">404</h1>
            <p className="error-message">
              Oups! La page que <br className="hide-desktop" /> vous demandez
              n'existe pas.
            </p>

            <Link className="link-to-homepage" to="/">
              Retourner sur la page d'accueil
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Error;
